import { Typography } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { useDecimalPlaces } from '@/hooks/useDecimalPlaces';
import { useFormatDate } from '@/hooks/useFormatDate';
import { EventDescription } from '@/types/event';
import { formatGameTimestamp } from '@/utils/games';
import { isNullish } from '@/utils/predicates';
import { snakeToCamel } from '@/utils/queries';

export const EventMapTooltip = ({
  markerDescription,
  obv,
  xg,
  gkSaveDifficultyXg,
}: {
  markerDescription: EventDescription;
  obv?: number | null;
  xg?: number | null;
  gkSaveDifficultyXg?: number | null;
}) => {
  const { t } = useTranslation('events');
  const formatDate = useFormatDate();
  const formatNumber = useDecimalPlaces();

  const eventType = t(`fields.event.type.${snakeToCamel(markerDescription.type)}`);
  const timestamp = formatGameTimestamp(markerDescription.minute, markerDescription.second);
  const safeFormat = (value: number) => formatNumber(2, Math.abs(value) < 0.005 ? 0 : value);
  return (
    <div className="max-w-[350px]">
      <Typography colour="inverse.main" variant="headingSmall" as="h3">
        {markerDescription.playerDisplayName} - {eventType}
      </Typography>
      <Typography colour="inverse.main" variant="bodyMedium" as="div">
        {timestamp} - {markerDescription.gameName}
      </Typography>
      <Typography colour="inverse.main" variant="bodyMedium" as="div">
        {markerDescription.competitionName} - {markerDescription.gameDate ? formatDate(markerDescription.gameDate) : ''}
      </Typography>
      {!isNullish(obv) && (
        <Typography colour="inverse.main" variant="bodyMedium" as="div">
          {t('keys.event.attributes.obvTotalNet')}: {safeFormat(obv)}
        </Typography>
      )}
      {!isNullish(xg) && (
        <Typography colour="inverse.main" variant="bodyMedium" as="div">
          {t('keys.event.attributes.xg')}: {safeFormat(xg)}
        </Typography>
      )}
      {!isNullish(gkSaveDifficultyXg) && (
        <Typography colour="inverse.main" variant="bodyMedium" as="div">
          {t('keys.event.attributes.gkSaveDifficultyXg')}: {safeFormat(gkSaveDifficultyXg)}
        </Typography>
      )}
    </div>
  );
};
